import { tPackageModel } from './tPackageModel';
import { tPatientModel } from './tPatientModel';
import { tChangeAcctModel } from './tChangeAcctModel';
import { tPaymentModel } from './tPaymentModel';
import { TshopModule } from '../pages/tshop/tshop.module';
import { tShopModel } from './tShopModel';

export class tBillPayModel {

    id: number;
    shopID: string;

    bpInvoiceNumber: string;
    bpLineNumber: number;
    bpPaymentNumber: string;
    bpDateTime: Date;
    bpPatientID: string;
    bpChangeID: string;
    bpConsultNumber: string;
    bpItemID: string;
    bpItemType: string;
    bpItemDesc: string;
    bpQty: number;
    bpStandardPrice: number;
    bpFinalPrice: number;
    bpLineAmount: number;
    bpArAmount: number;
    bpPackInvoiceNo: string;
    bpPackID: string;
    bpPackItemID: string;
    bpPackageQty: number;
    bpPackFaceAmt: number;
    bpEmployeeID: string;
    bpPrintName: string;
    bpPaymentMethodID: string;
    bpPaymentMethodName: string;
    bpRemark: string;

    bpRemark2: string;
    bpRemark3: string;
    bpRemark4: string;
    bpRemark5: string;

    bpPackDesc: string;
    bpPackDis: string;
    bpPackPatientID: string;

    bpPaymentRemark: string;
    ehVoucher: string;

    inActive: string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;

    status: string;


    // constructor(
    //     shopID: string,bpInvoiceNumber: string,
    //     bpLineNumber: number,bpPaymentNumber: string,bpDateTime: Date,
    //     bpPatientID: string,bpChangeID: string, bpConsultNumber: string,
    //     bpItemID: string, bpItemType: string, bpItemDesc: string, bpQty: number,
    //     bpStandardPrice: number, bpFinalPrice: number,  bpLineAmount: number,
    //     bpArAmount: number, bpPackInvoiceNo: string, bpPackItemID: string,
    //     bpPackageQty: number, bpPackFaceAmt: number, bpEmployeeID: string,
    //     bpPrintName: string, bpPaymentMethodID: string, bpPaymentMethodName: string,
    //     bpRemark: string, bpPaymentRemark: string, inActive: string,
    //     lastModifyDatetime: Date, lastModifyUserID: string) {
    //         this.shopID = shopID;
    //         this.bpInvoiceNumber =bpInvoiceNumber;
    //         this.bpLineNumber = bpLineNumber;
    //         this.bpPaymentNumber = bpPaymentNumber;
    //         this.bpDateTime = bpDateTime;
    //         this.bpPatientID = bpPatientID;
    //         this.bpChangeID = bpChangeID;
    //         this.bpConsultNumber = bpConsultNumber;
    //         this.bpItemID = bpItemID;
    //         this.bpItemType = bpItemType;
    //         this.bpItemDesc = bpItemDesc;
    //         this.bpQty = bpQty;
    //         this.bpStandardPrice = bpStandardPrice;
    //         this.bpFinalPrice = bpFinalPrice;
    //         this.bpLineAmount = bpLineAmount;
    //         this.bpArAmount = bpArAmount;
    //         this.bpPackInvoiceNo = bpPackInvoiceNo;
    //         this.bpPackItemID = bpPackItemID;
    //         this.bpPackageQty = bpPackageQty;
    //         this.bpPackFaceAmt = bpPackFaceAmt;
    //         this.bpEmployeeID = bpEmployeeID;
    //         this.bpPrintName = bpPrintName;
    //         this.bpPaymentMethodID = bpPaymentMethodID;
    //         this.bpPaymentMethodName = bpPaymentMethodName;
    //         this.bpRemark = bpRemark;
    //         this.bpPaymentRemark = bpPaymentRemark;
    //         this.inActive = inActive;
    //         this.lastModifyDatetime = lastModifyDatetime;
    //         this.lastModifyUserID = lastModifyUserID;

    // };


}


export class tBillPayModelWithItemCateInfo extends tBillPayModel {
    itemCateID: string;
    itemCateIsService: string;
    specialPaymentType:number;
}


export class BillPay_ItemType {
    // normal item & service which in item master
    static ITEM = 'I';

    // buy the package, which in package master
    static ITEM_PACKAGE = 'I-PK';

    // item
    static PRESCRIPTION = 'PC';

    // successful to buy the package
    static PATIENT_PACKAGE = 'Pat-PK';

    static PAYMENT = 'Payment';
    static PAYMENT_VOID = 'PaymentVoid';
    static PAYMENT_VOID_PACKAGE = 'PaymentVoid-PK';

}



export class BillPay_Patient_PackageModel {

    billPay: tBillPayModel;
    packageInfo: tPackageModel;
    expirationDate: Date;
    remainder: number;
    packageHolderName: string;

}

export class PatientRelative_PackageModel {
    selfpackage: BillPay_Patient_PackageModel[];
    otherPatientPackage: BillPay_Patient_PackageModel[];
    selfPrepay: BillPay_Patient_PackageModel[];
    otherPatientPrepay: BillPay_Patient_PackageModel[];
}

export class BillPay_Patient_Relative_ChangeAccount {

    patientInfo: tPatientModel;
    relativeChange: tChangeAcctModel;
}


export class BillPay_PatientHistoryList {
    shopID: string;
    bpDateTime: Date;
    bpConsultNumber: string;
    bpInvoiceNumber: string;
    clthPrescripNumber: string;
    clthPrescripNumberArray: string[];
    paymentNumber: string;
    voidPaymentNumber: string;
    billPayAmount:number;
    staffRemark:string;
    diagnosis: string;
    clthDetailDesc: string;
    isSaveRemark:boolean;
    isSaveConsultRemark:boolean;
}

export class new_BillPay_PatientHistoryList {
    shopID: string;
    lastModifyUserName:string;
    bpDateTime: Date;
    bpInvoiceNumber: string;
    bpItemID:string;
    bpItemDesc:string;
    bpUnitPrice:number;
    bpQty:number;
    bpAr:number;
    

}


export class tBillPayReportModel extends tBillPayModelWithItemCateInfo {
    patientChiName: string;
    patientSurname: string;
    patientFirstName: string;

    bpArAmountPaid: number;
    bpArAmountUnPaid: number;

    changeName: string;
}




export class BillPayPaymenyByItemPackageModel {
    itemRecord: tBillPayModel;
    paymentRecord: tBillPayModel;
}


export class DayEndReportDataModel {
    shopModel: tShopModel;
    paymentMethodListData: DayEndReport_PaymentMethodRowModel[];
    unpayListData: DayEndReport_unpayList[];
    sumChangeAcc: number;

}

export class DayEndReport_PaymentMethodRowModel {
    paymentModel: tPaymentModel;
    totalAmount: number;
    totalVoudAmount: number;
}

export class DayEndReport_unpayList {
    unpayBillNumber: string;
    unpayBillAmount: number;
    unpayPatientChiName: string;
    unpayPatientSurname: string;
    unpayPatientFirstName: string;
    unpayPatientID: string;
}



export class Report_PackageRemainderModel {

    //holder user
    usedPatientChiName: string;
    usedPatientSurname: string;
    usedPatientFirstName: string;
    usedPatientID: string;

    //package user
    usedPackagePatientID: string;
    usedPackagePatientChiName: string;

    packageName: string;

    shopID: string;
    shopName: string;

    bpInvoiceNumber: string;
    bpLineNumber: number;
    bpPaymentNumber: string;

    bpDateTime: Date;
    bpPatientID: string;
    bpChangeID: string;
    bpConsultNumber: string;

    bpItemID: string;
    bpItemDesc: string;
    bpItemType: string;

    bpQty: number;
    bpStandardPrice: number;
    bpFinalPrice: number;

    bpLineAmount: number;
    bpArAmount: number;
    bpPackInvoiceNo: string;
    bpPackItemID: string;
    bpPackageQty: number;
    bpPackFaceAmt: number;

    bpEmployeeID: string;
    bpPrintName: string;
    bpPaymentMethodID: string;

    bpPaymentMethodName: string;
    bpRemark: string;
    bpPaymentRemark: string;

    lastModifyDatetime: Date;
    lastModifyUserID: string;



}



export class Report_PackageRemainderModel_WithRemainder extends Report_PackageRemainderModel {

    packageRemainderFaceAmount: number;
    packageRemainderQty: number;

    constructor(packageRemainderFaceAmount: number, packageRemainderQty: number) {
        super();
        this.packageRemainderFaceAmount = packageRemainderFaceAmount;
        this.packageRemainderQty = packageRemainderQty;
    }
}



// export class Report_MonthSalesDataModel{

//     billPayInfo : Report_MonthSalesModel_Report[];
//     shopModel: tShopModel;

//     constructor(billPayInfo: Report_MonthSalesModel_Report[], shopModel: tShopModel){
//         this.billPayInfo = billPayInfo;
//         this.shopModel = shopModel;
//     }

// }




// export class Report_MonthSalesModel_Report extends tBillPayModel {

//     report_itemTotalQty: number;
//     report_itemTotalAmount: number;

//     constructor(report_itemTotalQty: number, report_itemTotalAmount: number) {
//         super();
//         this.report_itemTotalQty = report_itemTotalQty;
//         this.report_itemTotalAmount = report_itemTotalAmount;
//     }

// }



export class Report_MonthSalesModel_Package_ServerModel {

    billPayInfo: tBillPayModel;
    consultStatus: string;
    // constructor(billpayinfo: tBillPayModel, consultStatus: string){
    //     this.billpayinfo = billpayinfo;
    //     this.consultStatus = consultStatus;
    // }
}


export class Report_MonthSalesModel2 {

    bpItemID: string;
    bpItemDesc : string;
    totalQty: number;
    totalBill: number;
    totalAmount: number;
    // constructor(billpayinfo: tBillPayModel, consultStatus: string){
    //     this.billpayinfo = billpayinfo;
    //     this.consultStatus = consultStatus;
    // }
}


export class Report_MonthSalesModel_Package_PrintModel extends Report_MonthSalesModel_Package_ServerModel {

    report_itemTotalQty: number;
    report_itemTotalAmount: number;
    patientTypeID: string;
    patientTypeDesc: string;

    constructor(report_itemTotalQty: number, report_itemTotalAmount: number,patientTypeID:string , patientTypeDesc:string ) {
        super();
        this.report_itemTotalQty = report_itemTotalQty;
        this.report_itemTotalAmount = report_itemTotalAmount;
        this.patientTypeID = patientTypeID;
        this.patientTypeDesc = patientTypeDesc;

    }

}

// export class Report_MonthSalesModel_Package_Analysis_P777_Model extends Report_MonthSalesModel_Package_PrintModel {

//     report_patientType: string;
//     report_patientTypeDesc: string;

//     constructor(report_patientType: string, report_patientTypeDesc: string) {
//         super();
//         this.report_patientType = report_patientType;
//         this.report_patientTypeDesc = report_patientTypeDesc;
//     }

// }






export class BillPayStatus {
    public static WaitingAction: string = "WaitingAction";
    public static ReadyPayment: string = "ReadyPayment";
    public static ReadyPaymentChange: string = "ReadyPaymentChange";
    public static FinishPayment: string = "Completed";

}


export class Report_SalesSummaryModel {

    date: Date;
    numberOfCounsult: number;
    numberOfPeople: number;
    totalSalesAmount: number;
    totalChangeAmount: number;
    totalPrePayAmount: number;
    totalPackageAmount: number;
    allPaymentMethodList: SalesSummary_PaymentMethodModel[];


    totalSalesEnableAmount: number;
    totalSalesDisableAmount: number;
    totalSalesAmount_NotUnCount_Active: number;
}


export class SalesSummary_PaymentMethodModel {
    paymentModel: tPaymentModel;
    totalAmount : number;

}
